<template>
  <div>
    <data-table
      title="Contacts"
      titleHeading="h3"
      titleClass="text-info"

      table-ref="contacts-table"

      :url="'/contacts/org' + (this.org_id ? '/' + Number(this.org_id) : '')"

      :fields="fields"
      :org-badge="orgBadge"

      sort-field="name"

      :add-action="action"
      :add-props="addProps"

      detail-component="contact-detail-row">

    </data-table>



  </div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'

import Vue from 'vue'
import VueEvents from 'vue-events'

import ContactAction from '@/components/actions/ContactAction'
import ContactControls from '@/components/tables/controls/ContactControls'
import ContactDetail from '@/components/tables/details/ContactDetail'

Vue.use(VueEvents)

Vue.component('contact-detail-row', ContactDetail)
Vue.component('custom-contact-actions', ContactControls)

export default {
  mixins: [DateMixins],

  components: {
    ContactAction
  },

  props: {
    orgId: {
      type: Number,
      required: true
    },

    orgBadge: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    orgId: function (changed) {
      this.org_id = changed
    }
  },

  data () {
    return {
      action: ContactAction,
      addProps: {
        orgId: this.isTelco() ? this.org().id : this.orgId
      },
      org_id: this.isTelco() ? this.org().id : this.orgId,
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'name',
          sortField: 'name'
        },
        {
          title: 'Job Title',
          name: 'jobTitle',
          sortField: 'jobTitle',
          visible: !this.isMobile
        },
        {
          name: 'email',
          sortField: 'email'
        },
        {
          name: '__component:custom-contact-actions'
        }
      ]
    }
  }
}
</script>
